<figure class="figure">
  <img class="image" [src]="src" [alt]="alt" (error)="onError()" />

  <figcaption class="caption" *ngIf="displayCaption && caption">
    {{ caption }}
  </figcaption>
</figure>
